<template>
  <profile-section
    section-title="Activate Purchase"
  >
    <span
      v-for="pr in unrealizedPurchases"
      :key="pr.id"
    >
      <a
        href="#"
        @click="activatePurchase(pr.id)"
      >
        Activate {{ purchaseOrderName(pr.purchaseOrderId) }}
      </a><br>
    </span>
  </profile-section>
</template>

<script>
import ProfileSection from '@components/profile/section';

export default {
  components: { ProfileSection },
  props: {
    activeSection: {
      type: String,
    },
  },
  computed: {
    unrealizedPurchases() {
      const allUnrealized = this.$store.getters['purchaseReceipts/unrealized'];
      return allUnrealized;
    },
  },
  methods: {
    purchaseOrderName(id) {
      const purchaseOrders = this.$store.getters['purchaseOrders/all'];
      const purchaseOrder = purchaseOrders.find(po => po.id == id );
      return purchaseOrder.name;
    },
    activatePurchase(id) {
      const allUnrealized = this.$store.getters['purchaseReceipts/unrealized'];
      const unrealizedPurchaseReceipt = allUnrealized.find(pr => pr.id == id);
      this.$modal.show('delayed-purchase-modal', { purchaseReceipt: unrealizedPurchaseReceipt, dashboard: this.dashboard });
      console.log('Activating');
    },
  },
};
</script>
